import { AxiosResponse } from 'axios';
import apiClient from '../axios';
import {
  IFeedResourceEndpointParams,
  IFeedResourceEndpointResponse,
} from '../interfaces';
import { getFeedEndpointParams } from '../helpers';
import { Activity, ActivityFeedScope } from './interfaces';

export const getActivities = async (
  perPage: number,
  cursor?: string | null,
  scope?: ActivityFeedScope | null
): Promise<IFeedResourceEndpointResponse<Activity>> => {
  const feedParams: IFeedResourceEndpointParams = {
    cursor,
    perPage,
    filters: scope
      ? [{ field: 'scope', operator: '=', value: scope }]
      : undefined,
  };

  const response: AxiosResponse<IFeedResourceEndpointResponse<Activity>> =
    await apiClient.get(`/activity`, {
      params: getFeedEndpointParams(feedParams),
    });

  return response.data;
};
